function checkDocument(): boolean {
  return typeof document !== 'undefined'
}

export const hasDocument = checkDocument()
